import { FilterName } from 'store/models/dashboard';

export interface FilterItem {
    id: string;
    name: string;
    tip?: string;
}

export enum ProductTypes {
    Cpc = 'CLICKME_CPC',
    Auction = 'CLICKME_SEARCH_AUCTION',
}
export enum CampaignStates {
    Active = 'ACTIVE',
    Inactive = 'INACTIVE',
}
export enum BudgetStates {
    Low = 'LOW',
    Exhausted = 'EXHAUSTED',
}
export enum ModerationStates {
    InProcess = 'IN_PROCESS',
    PartlySuccess = 'PARTLY_SUCCESS',
    Failed = 'FAILED',
}

export type ProductFilterType = Record<ProductTypes, FilterItem>;
export const PRODUCT_FILTER: ProductFilterType = {
    [ProductTypes.Cpc]: {
        id: ProductTypes.Cpc,
        name: 'Dashboard.Filters.Filter.ProductType.cpc',
    },
    [ProductTypes.Auction]: {
        id: ProductTypes.Auction,
        name: 'Dashboard.Filters.Filter.ProductType.auction',
    },
};

export type CampaignStateType = Record<CampaignStates, FilterItem>;
export const CAMPAIGN_STATE_FILTER: CampaignStateType = {
    [CampaignStates.Active]: {
        id: CampaignStates.Active,
        name: 'Dashboard.Filters.Filter.CampaignState.active',
    },
    [CampaignStates.Inactive]: {
        id: CampaignStates.Inactive,
        name: 'Dashboard.Filters.Filter.CampaignState.inactive',
    },
};

export type BudgetStateType = Record<BudgetStates, FilterItem>;
export const BUDGET_STATE_FILTER: BudgetStateType = {
    [BudgetStates.Low]: {
        id: BudgetStates.Low,
        name: 'Dashboard.Filters.Filter.BudgetState.low',
        tip: 'Dashboard.Filters.Filter.BudgetState.low.tip',
    },
    [BudgetStates.Exhausted]: {
        id: BudgetStates.Exhausted,
        name: 'Dashboard.Filters.Filter.BudgetState.exhausted',
    },
};

export type ModerationStateType = Record<ModerationStates, FilterItem>;
export const MODERATION_STATE_FILTER: ModerationStateType = {
    [ModerationStates.InProcess]: {
        id: ModerationStates.InProcess,
        name: 'Dashboard.Filters.Filter.ModerationState.inProcess',
    },
    [ModerationStates.PartlySuccess]: {
        id: ModerationStates.PartlySuccess,
        name: 'Dashboard.Filters.Filter.ModerationState.partlySuccess',
    },
    [ModerationStates.Failed]: {
        id: ModerationStates.Failed,
        name: 'Dashboard.Filters.Filter.ModerationState.failed',
    },
};

export const FILTERS_RECEIVED_AS_OBJECT: FilterName[] = ['areas', 'professionalRoles', 'createdByUserIds'];

type FiltersReceivedAsObjectKeys = Extract<
    FilterName,
    (typeof FILTERS_RECEIVED_AS_OBJECT)[keyof typeof FILTERS_RECEIVED_AS_OBJECT]
>;

export type Filter = ProductFilterType | CampaignStateType | BudgetStateType | ModerationStateType;

export const FILTERS: Record<Exclude<FilterName, FiltersReceivedAsObjectKeys>, Filter> = {
    productTypes: PRODUCT_FILTER,
    campaignStatuses: CAMPAIGN_STATE_FILTER,
    budgetStatuses: BUDGET_STATE_FILTER,
    moderationStatuses: MODERATION_STATE_FILTER,
};
